// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"96":"91e842e4","976":"098cd66f","992":"6f40ba67"}[chunkId] + ".css";
};